function timelineItem(theme, ownerState) {
  const { breakpoints, borders } = theme;
  const { lastItem } = ownerState;

  const { borderWidth, borderColor } = borders;

  return {
    position: "relative",
    display: "flex",
    width: "100%",
    mb: lastItem ? "0" : "20px",

    // The vertical line - centered
    "&:after": {
      content: !lastItem ? "''" : "none",
      position: "absolute",
      top: "2rem",
      height: "100%",
      borderRight: `${borderWidth[2]} solid ${borderColor}`,

      left: "14px",

      [breakpoints.up("md")]: {
        left: "50%",
        transform: "translateX(-50%)",
      },
      [breakpoints.up("xl")]: {
        left: "14px",
        transform: "none",
      },
      [breakpoints.up("x3l")]: {
        left: "50%",
        transform: "translateX(-50%)",
      },
    },
  };
}

function timelineItemIcon(theme, ownerState) {
  const { palette, typography, functions } = theme;
  const { color } = ownerState;

  const { gradients, transparent } = palette;
  const { size, fontWeightMedium } = typography;
  const { linearGradient } = functions;

  return {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontSize: size.xl,
    fontWeight: fontWeightMedium,
    zIndex: 1,
    backgroundImage: linearGradient(gradients[color].main, gradients[color].state),
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: transparent.main,
  };
}

export { timelineItem, timelineItemIcon };
